<router-outlet />

@if (loader.visible()) {
  <div class="global-loader-overlay" aria-busy="true" aria-live="polite">
    @for (mountId of [loader.lottieMountId()]; track mountId) {
      <ng-lottie
        class="global-loader-lottie"
        width="128px"
        height="128px"
        [options]="lottieOptions"
      />
    }
  </div>
}
